var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStackHalfFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3885 9.22251L14.1899 9.70337C14.3477 9.79811 14.3989 10.0028 14.3043 10.1607C14.2761 10.2076 14.2368 10.2469 14.1899 10.275L7.99961 13.9892L1.80935 10.275C1.65149 10.1803 1.6003 9.97557 1.69502 9.81771C1.72316 9.77077 1.76243 9.73151 1.80935 9.70337L2.61074 9.22251L7.99961 12.4558L13.3885 9.22251ZM8.34261 3.095L14.1899 6.60337C14.3477 6.69809 14.3989 6.90284 14.3043 7.0607C14.2761 7.10762 14.2368 7.14689 14.1899 7.17503L7.99961 10.8892L1.80935 7.17503C1.65149 7.08032 1.6003 6.87557 1.69502 6.71771C1.72316 6.67079 1.76243 6.63153 1.80935 6.60337L7.65661 3.095C7.86774 2.96833 8.13147 2.96833 8.34261 3.095ZM7.99961 4.44413V7.0607V9.33431L12.0747 6.88921L7.99961 4.44413Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStackHalfFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stack-half-fill.670c01cf.svg";
export { ForwardRef as ReactComponent };